import ErrorKey from '@/util/ErrorKey';

export default {
  dismissError: 'Ok',
  pageNotFound: 'Not Found',
  pageNotFoundDetail: 'We are unable to find this content. You can find all our current products using the search bar.',

  [ErrorKey.NoServerResponse]: 'Unable to communicate with server. Please check your internet connection.',
  [ErrorKey.UnknownBackendError]: 'Unexpected server error.',
  [ErrorKey.GenericSave]: 'Unable to save data.',
  [ErrorKey.WrongAddress]: 'The address you entered is invalid.',
  [ErrorKey.NoCart]: 'This operation requires a shopping cart.',
  [ErrorKey.UnitNotFound]: 'Product {0} was placed in the cart with unit {1}, which doesn\'t exist on this product.',
  [ErrorKey.LoginStatusCheckFailed]: 'Failed to check authentication status.',
  [ErrorKey.AlreadyPending]: 'Operation already pending, please wait for it to finish first.',

  [ErrorKey.NoSuchCartItem]: 'This product is not in your shopping cart.',
  [ErrorKey.CartMergeAction]: 'Unable to merge with guest shopping cart.',
  [ErrorKey.CartFetchAction]: 'Unable to load your shopping cart.',
  [ErrorKey.CartSaveAction]: 'Unable to save your shopping cart.',
  [ErrorKey.AddressListFetchAction]: 'Unable to load addresses.',
  [ErrorKey.AddressSaveAction]: 'Unable to save this address.',
  [ErrorKey.AddressDeleteAction]: 'Unable to delete this address.',
  [ErrorKey.CategoriesFetchAction]: 'Unable to fetch categories.',
  [ErrorKey.LanguageChangeAction]: 'Unable to change display language.',
  [ErrorKey.UserFetchAction]: 'Unable to fetch user details.',
  [ErrorKey.UserPageSizeSaveAction]: 'Unable to save your page size.',
  [ErrorKey.UserCreateAction]: 'Unable to complete your registration, please try again.',
  [ErrorKey.UserUpdateAction]: 'Unable to update your user details.',
  [ErrorKey.ProductListFetchAction]: 'Unable to fetch products.',
  [ErrorKey.ProductDetailFetchAction]: 'Unable to fetch this product.',
  [ErrorKey.KeycloakInitializationAction]: 'Could not connect to login server.',
  [ErrorKey.ShopMinOrderValueFetchAction]: 'Unable to read settings.',
  [ErrorKey.CmsFetchAction]: 'Unable to fetch dynamic content',

  [ErrorKey.ConflictException]: 'Conflict with existing data.',
  [ErrorKey.DisabledUserException]: 'Your user account {0} is disabled.',
  [ErrorKey.DuplicateEmailException]: 'The email address {0} is already taken.',
  [ErrorKey.EmptyOrderException]: 'Please add something to your shopping cart before ordering.',
  [ErrorKey.ForbiddenShopException]: 'Access to shop {0} is not permitted. Are you using the correct account?',
  [ErrorKey.ForbiddenTenantException]: 'Access to tenant {0} is not permitted. Are you using the correct account?',
  [ErrorKey.ForbiddenUserException]: 'Your account is not permitted to do this.',
  [ErrorKey.IllegalShopException]: 'Shop {0} does not exist.',
  [ErrorKey.InvalidEssentialFilterException]: 'Unsupported essential filter {0}.',
  [ErrorKey.InvalidInputException]: 'Invalid input in field {0}.',
  [ErrorKey.InvalidShoppingCartAmountException]: 'Please add at least one unit of {0}.',
  [ErrorKey.MinSaleQuantityViolationException]: 'Please order at least {0} units of product {1}.',
  [ErrorKey.MissingTenantSettingsException]: 'Missing tenant seetings for {0}.',
  [ErrorKey.NoCategoryForProductException]: 'No category assigned to product {0}.',
  [ErrorKey.NoInvoiceAPIException]: 'Invoice access is not currently enabled.',
  [ErrorKey.NonEssentialProductException]: 'Product {0} is not in "My Products".',
  [ErrorKey.NoSuchAddressException]: 'Could not find address {0}.',
  [ErrorKey.NoSuchCartItemException]: 'This product is not currently in your shopping cart.',
  [ErrorKey.NoSuchCategoryException]: 'Unable to find category {0}.',
  [ErrorKey.NoSuchOrderException]: 'Could not find order {0}.',
  [ErrorKey.NoSuchProductException]: 'Unable to find product {0}.',
  [ErrorKey.NoSuchShoppingCartException]: 'Unable to find your shopping cart.',
  [ErrorKey.NoSuchUnitException]: 'Product {1} does not have unit {0}.',
  [ErrorKey.NoSuchUserException]: 'Unable to find user {0}.',
  [ErrorKey.IndexNotFoundException]: 'Unable to search.',
  [ErrorKey.ElasticsearchException]: 'Unable to search.',
  [ErrorKey.NoNodeAvailableException]: 'Search is currently not available.',
  [ErrorKey.AccessControlException]: 'Access denied.',
  [ErrorKey.TenantAccessDeniedException]: 'Access denied to {0}',
  [ErrorKey.ShopAccessDeniedException]: 'Access denied to {0}',
  [ErrorKey.CanNotDeleteDefaultAddress]: 'Please select a different default address before deleting this one.',
  [ErrorKey.DeliveryNotSupportedException]: 'We do not deliver to this location.',
  [ErrorKey.MissingOrderAddressException]: 'Please provide delivery and shipping address.',
  [ErrorKey.DeliverySlotExpiryException]: 'This delivery slot expired.',
  [ErrorKey.ExternalException]: 'An error occurred talking to an external service: {0}',
  [ErrorKey.NoSuchMegacardException]: 'No such Megacard or invalid zip code.',
  [ErrorKey.MegacardConflictException]: 'Your account already has a Megacard associated.',
  [ErrorKey.MegacardImportException]: 'Unable to request Megacard data.',
  [ErrorKey.UpdateDefaultAddress]: 'Unable to change default address.',
  [ErrorKey.AgeRestrictionException]: 'Due to sale of alcoholic beverages a minimum age of 18 years is required.',
  [ErrorKey.CmsNotFoundException]: 'Unable to find this dynamic content.',
  [ErrorKey.NoSuchShoppingListException]: 'Unable to find shopping list.',
  [ErrorKey.MissingAddressException]: 'Please provide an address.',
  [ErrorKey.ErpStatusException]: 'Internal system responded with an error. ' +
  'Please try again later or contact us. ({0})',
  [ErrorKey.ErpConnectException]: 'Unabel to connect to internal system. ' +
  'Please try again later or contact us.',
};
